// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-largeOnWide-badge-d8644e78"};